import { ConnectButton } from "@rainbow-me/rainbowkit";

function CheckWalletConnection() {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks
        const ready = mounted && authenticationStatus !== "loading";
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === "authenticated");

        return (
          <div
            {...(!ready && {
              "aria-hidden": true,
              style: {
                opacity: 0,
                pointerEvents: "none",
                userSelect: "none",
              },
            })}
          >
            {(() => {
              if (!connected) {
                return <span
                  onClick={(event) => {
                    openConnectModal(event);
                  }}
                >
                  Connect Wallet
                </span>;
              }
              if (chain.unsupported) {
                return <span
                  onClick={openChainModal}
                >
                  Connect Wallet
                </span>;
              }

              return <span
                onClick={openAccountModal}
              >
                Connect Wallet
              </span>;
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
}

export default CheckWalletConnection;
